/**
 * Top-level shell.
 *
 * The previous version of this file was a state machine that switched
 * between MENU / GAME / ONLINE_GAME / TUTORIAL / LEADERBOARD with useState
 * and conditional rendering, and it pushed empty state blobs into the
 * History API on each transition (so the address bar never changed).
 *
 * With react-router taking over both the navigation stack and the URL,
 * AppContainer is now just an RouterProvider mount point. All per-screen
 * logic (start-game callbacks, saved-session resumption, tutorial entry,
 * admin entry) moved into the route adapters in `routes.js`.
 *
 * Session-persistence helpers (saveSession, clearSession, getSavedSession)
 * moved to `savedSession.js` so the route adapters can import them without
 * a circular dependency through AppContainer.
 */
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import './AppContainer.css';

const AppContainer = () => <RouterProvider router={router} />;

export default AppContainer;
